import { useEffect, useState } from "react";
import "./index.scss";
import CustomLeafletMultiSpot from "../../components/CustomLeafletMultiSpot";
import utils from "../../utils";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import CheckMarks from "./components/CheckMarks";
import { MapMembers } from "../../types/common.interface";

import { initializeSocket, connectSocket, emitEvent, disconnectSocket } from '../../hooks/initializeSocket';

const DashboardScreen = () => {
  const [result, setResult] = useState<any>();
  const [isLoading  , setIsLoading] = useState<any>(true);
  const [showMwmbers, setShowMembers] = useState<MapMembers>({
    student: false,
    driver : false,
    school : false,
  });

  // useEffect(() => {
  //   initializeSocket();
  //   connectSocket();
  //   emitEvent(
  //     'managerData',
  //     undefined,
  //     (status: number, result: any) => {
  //       setResult({school: result.school, service: result.service});
  //       status === 2001 && setIsLoading(false);
  //     },
  //   );
  //   return () => disconnectSocket();
  // }, []);
  //
  // const userType = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  //
  // useEffect(() => {
  //   setShowMembers({
  //     student: result?.service?.length < 1 ? undefined : true,
  //     driver : result?.service?.length < 1 ? undefined : true,
  //     school : result?.school ?.length < 1 ? undefined : true,
  //   });
  // }, [result]);
  //
  // let cityInfo: any;
  //
  // if (Cookies.get("city") != "undefined") {
  //   cityInfo = JSON.parse(Cookies.get("city") as string);
  // } else {
  //   cityInfo = undefined;
  // }

  return (
    <>
      <section id="dashboard-screen-content">
        <CustomLeafletMultiSpot
          // defaultLatArea={cityInfo && cityInfo?.lat}
          // defaultLngArea={cityInfo && cityInfo?.lng}
          student={
            result?.service?.length >= 1 &&
            result?.service?.map((item: any) => item?.student)
          }
          driver={
            result?.service?.length >= 1 &&
            result?.service?.map((item: any) => {
              return {
                driver: item?.driver,
                driverLocation: item?.driverLocation[0] && item?.driverLocation[0].length !== null
                  ? item?.driverLocation[0]
                  : undefined,
              };
            })
          }
          school={result?.school}
          isLoading={isLoading}
          // userType={userType}
          showStudent={showMwmbers.student}
          showDriver={showMwmbers.driver}
          showSchool={showMwmbers.school}
          // !! --------------------------------------------------------------------------------------------------------
          // !! --------------------------------------------------------------------------------------------------------
          // !! ========================================================================================================
          // !! ========================================================================================================
          // !! ########################################################################################################
          // !! ########################################################################################################
          // defaultLatArea={
          //   resultSuperAgent?.data?.result[0]?.superAgentSchoolInformation?.city
          //     ?.lat
          // }
          // defaultLngArea={
          //   resultSuperAgent?.data?.result[0]?.superAgentSchoolInformation?.city
          //     ?.lng
          // }
          // !! ########################################################################################################
          // !! ########################################################################################################
          // !! ========================================================================================================
          // !! ========================================================================================================
          // !! --------------------------------------------------------------------------------------------------------
          // !! --------------------------------------------------------------------------------------------------------
        />
        <div className="check-marks">
          <CheckMarks state={showMwmbers} setState={setShowMembers} />
        </div>
      </section>
    </>
  );
};

export default DashboardScreen;
